import { Injectable } from '@angular/core';
import { generateClient } from 'aws-amplify/api';
import * as queries from '@graphql/queries';
import * as mutations from '@graphql/mutations';
import {
    CreatePopCategoriesInput,
    DeletePopCategoriesInput,
    ModelPopCategoriesFilterInput,
    PopCategories,
    UpdatePopCategoriesInput
} from '@app/core/services/api/API.service';
@Injectable({
    providedIn: 'root'
})
export class PopCategoriesService {
    private amplifyClient = generateClient();
    constructor() {}

    async listPopCategories(): Promise<PopCategories[]> {
        try {
            const data = (
                await this.amplifyClient.graphql({
                    query: queries.listPopCategories
                })
            ).data.listPopCategories.items;
            if (data) return data as PopCategories[];
        } catch (error) {
            console.error('Error finding PopCategories:', error);
            return null;
        }
    }

    async listAllPopCategories(
        filter: ModelPopCategoriesFilterInput = null,
        pageLimit: number = 100
    ): Promise<PopCategories[]> {
        const categories: PopCategories[] = [];
        let nextToken: string | null = null;

        try {
            do {
                const response = (
                    await this.amplifyClient.graphql({
                        query: queries.listPopCategories,
                        variables: {
                            filter,
                            limit: pageLimit,
                            nextToken
                        }
                    })
                ).data.listPopCategories;
                categories.push(
                    ...((response?.items ?? []) as PopCategories[])
                );
                nextToken = response?.nextToken ?? null;
            } while (nextToken !== null);
            return categories;
        } catch (error) {
            console.error('Error finding PopCategories:', error);
            return [];
        }
    }
    async popCategoriesByMaterial(
        materialId: string
    ): Promise<PopCategories[]> {
        try {
            const data = (
                await this.amplifyClient.graphql({
                    query: queries.PopCategoriesByMaterial,
                    variables: {
                        materialId
                    }
                })
            ).data.PopCategoriesByMaterial.items;
            if (data) return data as PopCategories[];
        } catch (error) {
            console.error('Error finding PopCategories:', error);
            return null;
        }
    }

    async createPopCategories(
        input: CreatePopCategoriesInput
    ): Promise<PopCategories> {
        try {
            const data = (
                await this.amplifyClient.graphql({
                    query: mutations.createPopCategories,
                    variables: {
                        input
                    }
                })
            ).data.createPopCategories;
            if (data) return data as PopCategories;
        } catch (error) {
            console.error('Error creating PopCategories:', error);
            return null;
        }
    }
    async updatePopCategories(
        input: UpdatePopCategoriesInput
    ): Promise<PopCategories> {
        try {
            const data = (
                await this.amplifyClient.graphql({
                    query: mutations.updatePopCategories,
                    variables: {
                        input
                    }
                })
            ).data.updatePopCategories;
            if (data) return data as PopCategories;
        } catch (error) {
            console.error('Error creating PopCategories:', error);
            return null;
        }
    }

    async deletePopCategories(
        input: DeletePopCategoriesInput
    ): Promise<PopCategories> {
        try {
            const data = (
                await this.amplifyClient.graphql({
                    query: mutations.deletePopCategories,
                    variables: {
                        input
                    }
                })
            ).data.deletePopCategories;
            if (data) return data as PopCategories;
        } catch (error) {
            console.error('Error deleting PopCategories:', error);
            return null;
        }
    }
}
